import { Route, Routes, Link,useNavigate } from "react-router-dom";
import "./App.css";
import { useState, useEffect } from "react";
import { Auth } from "./components/Auth";
import { Header } from "./components/Header";
import { ProjectTypeSelector } from "./components/ProjectTypeSelector";
import { ProjectCorporate } from "./components/ProjectCorporate";
import { ProjectSovereign } from "./components/ProjectSovereign";
import { ReportHistory } from "./components/ReportHistory";
import { ReportDetail } from "./components/ReportDetail";
import { ReportRun } from "./components/ReportRun";
import {UserMenu} from "./components/UserMenu";
import {restApiBase} from "./settings";

function capitalizeFirst(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}


function App() {
    const [userIsAuthorized, setUserAuth] = useState(false);
    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [userName, setUserName] = useState(null);
    const [userMail, setUserMail] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const savedToken = localStorage.getItem("token");
        const savedUserId = localStorage.getItem("userId");
        const savedUserName = localStorage.getItem("userName");
        const savedUserMail = localStorage.getItem("userMail");

        if (savedToken && savedUserId) {
            setToken(savedToken);
            setUserId(savedUserId);
            setUserAuth(true);
            setUserName(savedUserName || null);
            setUserMail(savedUserMail || null);
        }
    }, []);

    function onAuth(token, userId, userName, userMail) {
        setToken(token);
        setUserId(userId);
        setUserAuth(true);
        setUserName(userName);
        setUserMail(userMail);
        localStorage.setItem("token", token);
        localStorage.setItem("userId", userId);
        localStorage.setItem("userName", userName);
        localStorage.setItem("userMail", userMail);
    }

    function logout() {

        setToken(null);
        setUserId(null);
        setUserAuth(false);
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("userName");
        localStorage.removeItem("userMail");
        setSidebarOpen(false);

        navigate("/");
    }

    //console.log(process.env.NODE_ENV);
    //console.log(restApiBase);

    if (!userIsAuthorized) return <Auth onAuth={onAuth} />;

    return (
        <div className="page">
            {sidebarOpen && <div className="overlay" onClick={() => setSidebarOpen(false)} />}
            <div className="workarea">

                {/* Верхний мобильный Header */}
                <div className="mobile-header d-md-none d-flex align-items-center justify-content-between p-2 border-bottom">
                    <div className="container">
                    {/* Логотип слева */}
                    <div className="logo">
                        <Link to="/">
                            <span className="color-primary">AI</span>nvestor
                        </Link>

                    </div>
                    </div>
                    {/* Гамбургер справа */}
                    <button
                        className="hamburger btn btn-light"
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                    >
                        &#9776;
                    </button>
                </div>

                {sidebarOpen && <div className="overlay" onClick={() => setSidebarOpen(false)} />}


                <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
                    <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
                    <div className="new-report item rounded-2">
                        <Link
                            to="/"
                            className="btn w-100 text-start d-flex"
                            onClick={() => setSidebarOpen(false)}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="custom-icon" aria-hidden="true">
                                <path d="M2.667 11.333V8.667c0-.922 0-1.654.048-2.243.049-.596.15-1.105.388-1.571l.154-.275c.384-.626.935-1.136 1.594-1.472l.177-.083c.418-.179.873-.263 1.396-.306.589-.048 1.321-.048 2.243-.048h.5c.367 0 .665.298.665.666 0 .368-.297.666-.665.666h-.5c-.944 0-1.612 0-2.135.042-.386.032-.66.085-.877.163l-.2.086c-.439.223-.807.564-1.063.982l-.102.184c-.126.247-.206.561-.248 1.076-.043.523-.043 1.192-.043 2.136v2.667c0 .944 0 1.613.043 2.136.042.515.122.829.248 1.076l.102.184c.256.418.624.759 1.063.982l.2.086c.217.078.491.131.877.163.523.042 1.191.043 2.135.043h2.667c.944 0 1.613 0 2.136-.043.515-.043.789-.095 1.005-.213l.185-.094c.418-.256.758-.623.982-1.063l.086-.2c.078-.217.13-.491.162-.877.048-.523.048-1.191.048-2.135v-.5c0-.367.297-.665.665-.666.367 0 .665.298.665.666v.5c0 .922 0 1.654-.048 2.243-.042.522-.126.977-.305 1.395l-.083.177c-.335.658-.845 1.209-1.472 1.593l-.275.154c-.465.237-.974.338-1.57.387-.59.048-1.322.048-2.244.048h-2.667c-.922 0-1.654 0-2.243-.048-.522-.043-.977-.127-1.395-.306l-.177-.083c-.658-.335-1.209-.845-1.593-1.472l-.154-.275c-.238-.465-.339-.974-.388-1.57-.048-.59-.048-1.322-.048-2.244ZM13.465 3.113c.955-.779 2.364-.723 3.255.168l.167.184c.728.892.728 2.18 0 3.072l-.167.185-5.047 5.048c-.535.535-1.21.906-1.944 1.072l-.317.058-1.817.26c-.207.03-.416-.04-.564-.188-.148-.148-.218-.357-.189-.564l.26-1.817.058-.317c.167-.734.538-1.409 1.072-1.944l5.047-5.047ZM15.779 4.221c-.404-.404-1.043-.43-1.476-.077l-.084.076-5.047 5.048c-.357.357-.605.807-.716 1.297l-.039.212-.135.938.94-.135.212-.039c.49-.111.94-.36 1.297-.717l5.047-5.047.084-.084c.33-.404.33-.988 0-1.392Z"/>
                            </svg>

                            New report
                        </Link>
                    </div>
                    <ReportHistory token={token} userId={userId} />
                    <div
                        className="logout btn col-auto d-flex flex-align-start"

                    >
                        <div className="d-flex align-items-center">
                            <UserMenu
                                userName={userName}
                                userMail={userMail}
                                onLogout={logout}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="col d-flex flex-column">
                        <div className="flex-1">
                            <Routes>
                                <Route path="/" element={<ProjectTypeSelector userName={userName} />} />
                                <Route
                                    path="/sovereign"
                                    element={<ProjectSovereign userId={userId} token={token} />}
                                />
                                <Route
                                    path="/corporate"
                                    element={<ProjectCorporate userId={userId} token={token} />}
                                />
                                <Route
                                    path="/report/run/:reportId"
                                    element={<ReportRun userId={userId} token={token} />}
                                />
                                <Route
                                    path="/report/detail/:reportId"
                                    element={<ReportDetail userId={userId} token={token} />}
                                />
                            </Routes>

                        </div>
                        <div className="copyright">
                            Copyright © 2026. <a target="_blank" href="https://ainvestgroup.com">AINVEST GROUP LLC</a>. All rights reserved.
                            {(process.env.NODE_ENV === "development") && <span className="ms-2">Dev API</span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
